import { createGlobalStyle } from 'styled-components';
import tw, { GlobalStyles as BaseStyles, theme } from 'twin.macro';

import Fonts from './Fonts';

const CustomStyles = createGlobalStyle`
  html {
    scroll-behavior: smooth;
  }

  body {
    -webkit-tap-highlight-color: ${theme<string>`colors.purple.500`};
    background-color: #070215;
    ${tw`antialiased font-lores12`}
  }

  * {
    box-sizing: border-box;
    font-family: inherit;
    letter-spacing: 0.1em;
    ${tw`text-base text-white`}
  }

  ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  
  ::-webkit-scrollbar-track {
    border-radius: 6px;
    background: transparent;
  }
  
  ::-webkit-scrollbar-thumb {
    border-radius: 6px;
    background: #0C1938;
    box-shadow: inset 0 0 4px #fff2;
  }

  .Toastify * {
    ${tw`text-black`}
  }

  .collection-card-carousel-item {
    transition: all 0.5s ease-out;
  }

  @keyframes rising-up {
    from {
      margin-bottom: -100%;
    }

    to {
      margin-bottom: 0;
    }
  }

  .popup-content {
    animation: rising-up 0.4s ease-out;
  }

  @keyframes dropdown {
    from {
      transform: scaleY(0);
    }

    to {
      transform: scaleY(1);
    }
  }

  .dropdown-list {
    transform-origin: left top;
    animation: dropdown 0.25s ease-out;
  }

  .tags-line::-webkit-scrollbar {
    display: none;
  }
`;

const GlobalStyles = () => (
  <>
    <Fonts />
    <BaseStyles />
    <CustomStyles />
  </>
);

export default GlobalStyles;
